
import React from "react";
import { ShieldAlert } from "lucide-react";

const MatchCards = ({ data }) => {
  const cards = data?.cards || [];
  const info = data?.info || {};

  const homeTeam = info?.match_hometeam_name;
  const awayTeam = info?.match_awayteam_name;

  return (
    <div className="w-full rounded-3xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="px-5 py-4 border-b border-zinc-100 dark:border-zinc-800 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-bold text-zinc-900 dark:text-white">
            Match Cards
          </h2>
          <p className="text-sm text-zinc-500 dark:text-zinc-400">
            Yellow & Red Card Events
          </p>
        </div>

        <div className="flex items-center gap-2 bg-yellow-100 dark:bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 px-3 py-1 rounded-full text-sm font-semibold">
          <ShieldAlert size={16} />
          {cards.length}
        </div>
      </div>

      {/* No Cards Found */}
      {cards.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
          <div className="w-20 h-20 rounded-full bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center mb-4">
            <ShieldAlert
              size={34}
              className="text-zinc-400 dark:text-zinc-500"
            />
          </div>

          <h3 className="text-lg font-semibold text-zinc-800 dark:text-zinc-200">
            No Cards Found
          </h3>

          <p className="text-sm text-zinc-500 dark:text-zinc-400 mt-1 max-w-sm">
            No yellow or red cards were issued during this match.
          </p>
        </div>
      ) : (
        <div className="divide-y divide-zinc-100 dark:divide-zinc-800">
          {cards.map((item, index) => {
            const isHome = !!item?.home_fault;
            const playerName = item?.home_fault || item?.away_fault;
            const teamName = isHome ? homeTeam : awayTeam;

            return (
              <div
                key={index}
                className="group px-4 py-4 hover:bg-zinc-50 dark:hover:bg-zinc-800/50 transition-all duration-300"
              >
                <div className="flex items-start gap-4">
                  {/* Time */}
                  <div className="min-w-[55px]">
                    <div className="bg-zinc-100 dark:bg-zinc-800 text-zinc-900 dark:text-white text-sm font-bold px-3 py-1 rounded-xl text-center">
                      {item?.time}'
                    </div>
                  </div>

                  {/* Timeline */}
                  <div className="flex flex-col items-center">
                    <div
                      className={`
                        w-4 h-5 rounded-sm border shadow-sm
                        ${
                          item?.card?.toLowerCase().includes("red")
                            ? "bg-red-500 border-red-600"
                            : "bg-yellow-400 border-yellow-500"
                        }
                      `}
                    />

                    {index !== cards.length - 1 && (
                      <div className="w-[2px] h-12 bg-zinc-200 dark:bg-zinc-700 mt-1" />
                    )}
                  </div>

                  {/* Details */}
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="text-base font-semibold text-zinc-900 dark:text-white">
                        {playerName}
                      </h3>

                      <span
                        className={`
                          text-xs font-semibold px-2.5 py-1 rounded-full capitalize
                          ${
                            item?.card?.toLowerCase().includes("red")
                              ? "bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-400"
                              : "bg-yellow-100 text-yellow-700 dark:bg-yellow-500/10 dark:text-yellow-400"
                          }
                        `}
                      >
                        {item?.card}
                      </span>
                    </div>

                    <div className="mt-1 flex flex-wrap items-center gap-2 text-sm">
                      <span className="text-zinc-600 dark:text-zinc-300 font-medium">
                        {teamName}
                      </span>

                      <span className="text-zinc-400">•</span>

                      <span className="text-zinc-500 dark:text-zinc-400">
                        {item?.score_info_time}
                      </span>
                    </div>

                    {item?.info && (
                      <p className="mt-2 text-sm text-zinc-500 dark:text-zinc-400">
                        {item?.info}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MatchCards;